import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import api from "../lib/api";
import HScroll from "./HScroll";

export default function PartnersStrip() {
  const [partners, setPartners] = useState([]);
  useEffect(() => { api.get("/partners").then((r) => setPartners(r.data)).catch(() => {}); }, []);
  if (partners.length === 0) return null;

  return (
    <section className="editorial-sand-glow py-20 lg:py-24 border-y border-primary/10" data-testid="partners-strip">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-10 lg:mb-14">
          <p className="text-xs uppercase tracking-[0.25em] text-primary font-bold mb-3">Ils nous soutiennent</p>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-foreground leading-[1.05]">
            Nos partenaires <span className="italic font-light text-primary">de confiance</span>
          </h2>
        </div>
        <HScroll testId="partners-carousel" itemWidthClass="w-[280px] sm:w-[320px] lg:w-[340px]">
          {partners.map((p) => {
            const hasWebsite = !!(p.website && p.website.trim());
            return (
              <article
                key={p.id}
                className="group card-surface card-lift overflow-hidden flex flex-col h-full"
                data-testid={`partner-${p.id}`}
              >
                {/* Logo — larger, on soft neutral bg to preserve brand colors */}
                <div className="relative aspect-[16/10] bg-white flex items-center justify-center p-8 border-b border-primary/5">
                  {p.logo_url ? (
                    <img
                      src={p.logo_url}
                      alt={`Logo ${p.name}`}
                      loading="lazy"
                      className="max-h-full max-w-full w-auto h-auto object-contain transition-transform duration-500 group-hover:scale-[1.04]"
                    />
                  ) : (
                    <span className="font-display font-bold text-2xl text-foreground/40 text-center leading-tight">{p.name}</span>
                  )}
                </div>
                {/* Title + description */}
                <div className="p-5 lg:p-6 flex flex-col flex-1 gap-2">
                  {hasWebsite ? (
                    <a
                      href={p.website}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-start gap-1.5 font-display font-bold text-lg leading-tight text-foreground hover:text-primary transition-colors"
                      data-testid={`partner-title-${p.id}`}
                    >
                      <span className="flex-1">{p.name}</span>
                      <ExternalLink className="w-3.5 h-3.5 mt-1 opacity-0 group-hover:opacity-100 transition-opacity flex-shrink-0" aria-hidden />
                    </a>
                  ) : (
                    <span className="font-display font-bold text-lg leading-tight text-foreground" data-testid={`partner-title-${p.id}`}>
                      {p.name}
                    </span>
                  )}
                  {p.description && (
                    <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">
                      {p.description}
                    </p>
                  )}
                  {hasWebsite && (
                    <a
                      href={p.website}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-flex items-center gap-1.5 text-primary text-xs font-semibold mt-auto pt-3 group-hover:gap-2.5 transition-all"
                      data-testid={`partner-visit-${p.id}`}
                    >
                      Visiter le site <ExternalLink className="w-3 h-3" />
                    </a>
                  )}
                </div>
              </article>
            );
          })}
        </HScroll>
      </div>
    </section>
  );
}
